import { render } from "./PoliticasDeCookies.vue?vue&type=template&id=d9a70e1c&scoped=true"
import script from "./PoliticasDeCookies.vue?vue&type=script&lang=js"
export * from "./PoliticasDeCookies.vue?vue&type=script&lang=js"

import "./PoliticasDeCookies.vue?vue&type=style&index=0&id=d9a70e1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9a70e1c"]])

export default __exports__